import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, toDisplayString as _toDisplayString, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal-container" }
const _hoisted_2 = { class: "label-row" }
const _hoisted_3 = ["disabled"]

import { VueFinalModal } from 'vue-final-modal';
import TeamMemberForm from '../forms/TeamMemberForm.vue';
import { UserItem } from '@/services/entities/UserItem';
import { reactive } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'TeamMemberSelectModal',
  emits: ["close", "save"],
  setup(__props, { emit: __emit }) {

const props = reactive({
    user: {} as UserItem,
    buttonCaption: 'Add Member',
    clearSelection: true,
    asLeader: false,
});
const emit = __emit;

function saveClicked() {
  emit('save', props.user, props.asLeader);
}

function clearSelection() {
  if (props.clearSelection) props.user = {} as UserItem;
}

function enableAddButton(): boolean {
  return props.user.id != null && props.user.id.length > 0;
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(VueFinalModal), {
    class: "modal",
    "content-class": "modal-content",
    "overlay-transition": "vfm-fade",
    clickToClose: false,
    onOpened: clearSelection,
    onClickOutside: _cache[2] || (_cache[2] = ($event: any) => (emit('close')))
  }, {
    default: _withCtx(() => [
      _createVNode(TeamMemberForm, {
        user: props.user,
        "only-local-users": !props.asLeader
      }, null, 8, ["user", "only-local-users"]),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[3] || (_cache[3] = _createElementVNode("label", null, "As Leader", -1)),
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((props.asLeader) = $event))
          }, null, 512), [
            [_vModelCheckbox, props.asLeader]
          ])
        ]),
        _createElementVNode("button", {
          class: "accent",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('close')))
        }, "Cancel"),
        _createElementVNode("button", {
          class: "accent",
          onClick: saveClicked,
          disabled: !enableAddButton()
        }, _toDisplayString(props.buttonCaption), 9, _hoisted_3)
      ])
    ]),
    _: 1
  }))
}
}

})